<div
  class="matero-container-wrap"
  [ngClass]="{
    'matero-sidenav-collapsed': options.sidenavCollapsed && options.navPos !== 'top',
    'matero-navbar-side': options.navPos === 'side',
    'matero-navbar-top': options.navPos === 'top',
    'matero-header-above': options.headerPos === 'above',
    'matero-header-fixed': options.headerPos === 'fixed',
    'matero-header-white': options.theme !== 'dark',
  }"
  [dir]="options.dir"
>
  <ng-progress ngProgressHttp />

  <div
    class="matero-interactive-shell"
    [attr.inert]="isApiUnavailable() ? '' : null"
    [attr.aria-hidden]="isApiUnavailable() ? 'true' : null"
  >
    <mat-sidenav-container class="matero-container" autoFocus>
      <mat-sidenav
        #sidenav
        class="matero-sidenav mat-secondary"
        [mode]="isOver ? 'over' : 'side'"
        [opened]="options.navPos === 'side' && options.sidenavOpened && !isOver"
        (openedChange)="onSidenavOpenedChange($event)"
        (closedStart)="onSidenavClosedStart()"
      >
        <app-sidebar
          [showToggle]="shouldShowSidebarToggle"
          [showUser]="!!options.showUserPanel"
          (toggleCollapsed)="toggleCollapsed()"
          [toggleChecked]="!!options.sidenavCollapsed"
          [isPopupMinimized]="isPopupMinimized$ | async"
          [isPopupEnabled]="isPopupEnabled$ | async"
          [popupContent]="(popupContent$ | async) || ''"
          (reopenPopup)="onReopenPopup()"
          (dismissPopup)="onDismissPopup()"
        >
        </app-sidebar>
      </mat-sidenav>

      <mat-sidenav #sidenavNotice position="end" mode="over">
        <app-sidebar-notice></app-sidebar-notice>
      </mat-sidenav>

      <mat-sidenav-content #content class="matero-content-wrap">
        @if (options.showHeader) {
          <app-header (toggleSidenavNotice)="sidenavNotice.toggle()"></app-header>
        }

        @if (options.navPos === 'top') {
          <app-topmenu></app-topmenu>
        }

        <div class="matero-content">
          <router-outlet></router-outlet>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>

    <app-multi-summary></app-multi-summary>
    <app-two-factor-auth-monitor></app-two-factor-auth-monitor>
    <app-survey-icon></app-survey-icon>
  </div>

  @if (isApiUnavailable()) {
    <div class="api-unavailable-overlay">
      <section
        class="api-unavailable-card"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="api-unavailable-title"
        aria-describedby="api-unavailable-description"
        cdkTrapFocus
        [cdkTrapFocusAutoCapture]="true"
      >
        <div class="api-unavailable-icon" aria-hidden="true">
          <span class="material-icons">cloud_off</span>
        </div>
        <div class="api-unavailable-copy">
          <p class="api-unavailable-eyebrow">Connection interrupted</p>
          <h1 id="api-unavailable-title">We can’t reach OneRay right now</h1>
          <p id="api-unavailable-description">
            The service may be restarting or temporarily unavailable. This page is paused to avoid
            showing incomplete information.
          </p>
        </div>
        <button
          type="button"
          class="api-unavailable-retry"
          cdkFocusInitial
          (click)="retryConnection()"
        >
          <span class="material-icons" aria-hidden="true">refresh</span>
          Try again
        </button>
        <p class="api-unavailable-note">If the problem continues, contact your administrator.</p>
      </section>
    </div>
  }
</div>
